namespace TabAurous.OMS {
    export interface ProductInspectionForm {
        ProcessId: Serenity.LookupEditor;
        Parameter: Serenity.StringEditor;
        Value: Serenity.StringEditor;
        IsNumeric: Serenity.BooleanEditor;
        Min: Serenity.DecimalEditor;
        Max: Serenity.DecimalEditor;
    }

    export class ProductInspectionForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductInspection';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductInspectionForm.init)  {
                ProductInspectionForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(ProductInspectionForm, [
                    'ProcessId', w0,
                    'Parameter', w1,
                    'Value', w1,
                    'IsNumeric', w2,
                    'Min', w3,
                    'Max', w3
                ]);
            }
        }
    }
}
